import {
  WORKSPACE_AGENT_ONBOARDING_TIME_SINKS,
  type WorkspaceAgentOnboardingTimeSinkId,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentOnboardingHandoff';

export type WorkspaceAgentOnboardingWinningTimeSink = (typeof WORKSPACE_AGENT_ONBOARDING_TIME_SINKS)[number];

/** `0` is the lowest rank. Every other priority runs in ascending order. */
const getWorkspaceAgentOnboardingTimeSinkRank = (priority: number): number =>
  priority === 0 ? Number.POSITIVE_INFINITY : priority;

/** Selected pills, highest priority first. */
export const sortWorkspaceAgentOnboardingTimeSinksByPriority = (
  timeSinks: readonly WorkspaceAgentOnboardingWinningTimeSink[],
): WorkspaceAgentOnboardingWinningTimeSink[] =>
  [...timeSinks].sort(
    (left, right) =>
      getWorkspaceAgentOnboardingTimeSinkRank(left.priority) - getWorkspaceAgentOnboardingTimeSinkRank(right.priority),
  );

/** The selected pill with the best priority. Tap order does not matter. */
export const getWorkspaceAgentOnboardingWinningTimeSink = (
  timeSinkIds: readonly WorkspaceAgentOnboardingTimeSinkId[],
): WorkspaceAgentOnboardingWinningTimeSink | null =>
  sortWorkspaceAgentOnboardingTimeSinksByPriority(
    WORKSPACE_AGENT_ONBOARDING_TIME_SINKS.filter((timeSink) => timeSinkIds.includes(timeSink.id)),
  )[0] ?? null;
